import React from 'react'
import TimePoint from './TimePoint'
import { Link } from 'react-router-dom'
import '../css/IndustryColumn.scss'

const IndustryColumn = ({ industry, count, times, industryKey, index, industryHoverHandler }) => {
  // maybe use filter to create sorted industry-specific objects
  return (
    <div className='industry_column fade-up' style={{ transitionDelay: `${index / 25}s` }}>
      <div className='column_header'>
        <Link
          to={`industry/${industryKey}`}
          onMouseEnter={() => industryHoverHandler(industryKey, true)}
          onMouseLeave={() => industryHoverHandler(industryKey, false)}
        ><h3 className='industry_title industry-link'>{industry.title}</h3></Link>
      </div>
      { window.innerWidth > 1024
        ? <div className='times_container'>
          {
            times.map(time => <TimePoint time={time} key={time.key} />)
          }
        </div>
        : ''}
    </div>
  )
}

export default IndustryColumn
